import React from 'react';
export const PageLoader = () => {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-1404">
      <div className="text-center" data-id="element-1405">
        <div className="inline-block w-10 h-10 border-3 border-gray-300 border-t-gray-800 rounded-full animate-spin mb-4" style={{
        borderWidth: '3px'
      }} data-id="element-1406" />
        <p className="text-gray-500 text-sm font-medium" data-id="element-1407">Loading...</p>
      </div>
    </div>;
};